import { Component, inject } from '@angular/core';

import { AuthService } from '../../../authentication/_services/auth.service';

@Component({
  selector: 'app-web-console-restricted',
  standalone: false,
  templateUrl: './web-console-restricted.component.html',
  styleUrl: './web-console-restricted.component.scss'
})
export class WebConsoleRestrictedComponent {
  private authService = inject(AuthService);

  logout(): void {
    this.authService.logout();
  }
}
